import { Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'hs-app-header-button',
  templateUrl: './app-header-button.component.html',
  styleUrls: ['./app-header-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppHeaderButtonComponent {
  @Input() icon = ''
  @Input() isLoading = false
  @Input() isActive = false
  @Input() isDisabled = false
  @Input() badgeCount = 0
  @Input() badgeColor = 'blue'
}
